<template>
  <button v-if="!showMore" @click="showMore = true">Learn more</button>
  <div v-else>
    <slot />
    <!-- <button @click="showMore = false">Show less</button> -->
  </div>
</template>
<script>
export default {
  name: 'LearnMoreBtn',
  data() {
    return {
      showMore: false,
    }
  },
}
</script>
<style scoped lang="scss">
button {
  font: normal normal normal 15px/1.875em raleway, sans-serif;
  background: $color-primary-2;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 3px;
  margin-top: 20px;
}
</style>
